import styled from "styled-components"
import Form from "YConnect/Containers/Form.container"

const FormStyle = styled(Form)`
    margin-top: 0 !important;
`
export default FormStyle